import { Page } from 'redux/common';
import { WxUser } from './actions';
import { WxUserActionTypes } from './constants';

const INIT_STATE = {
  accountList: [],
  error: '',
  loading: false,
};

type WxUserActionType = {
  type:
  | WxUserActionTypes.API_RESPONSE_SUCCESS
  | WxUserActionTypes.API_RESPONSE_ERROR
  | WxUserActionTypes.LIST_WXUSERS
  | WxUserActionTypes.RESET

  payload: {
    actionType?: string;
    data?: WxUser[] | WxUser | {};
    error?: string;
    id?: number;
    page: Page;
  }
}

type State = {
  accountList?: WxUser[];
  loading?: boolean;
  error?: string
};

const findSlice = (data: WxUser[], accountListId: number): number => {
  let idx = data.findIndex((a) => a.id === accountListId);
  return idx < 0 ? data.length : idx;
}

const WxUsers = (state: State = INIT_STATE, action: WxUserActionType) => {
  switch (action.type) {
    case WxUserActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case WxUserActionTypes.LIST_WXUSERS: {
          return {
            ...state,
            accountList: action.payload.data,
            page: action.payload.page,
            loading: false,
          }
        }
        default:
          return { ...state };
      }
    case WxUserActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case WxUserActionTypes.LIST_WXUSERS: {
          return {
            ...state,
            error: (action.payload.error as any).message,
            loding: false,
          }
        }
        default:
          return { ...state };
      }
    case WxUserActionTypes.LIST_WXUSERS:
      return { ...state, loading: true }
    case WxUserActionTypes.RESET:
      return {
        ...state,
        ...INIT_STATE,
      }
    default:
      return { ...state };
  }
}

export default WxUsers;
